module.exports = __webpack_public_path__ + "img/beijing.f3d6ecc9.jpg";